// TODO: remove this file if this file replaces the default RichMediaTextEditorWrapper.tsx
/* istanbul ignore file */
import { useCallback } from 'react';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { Props } from './RichMediaTextEditorSunrise';

export const RichMediaTextEditorWrapper: React.FC<Props> = (props) => {
	const loadComponent = useCallback(
		async () =>
			(await import(/* webpackChunkName: "cmp/rich_media_text_editor_sunrise" */ './RichMediaTextEditorSunrise'))
				.RichMediaTextEditor,
		[],
	);

	return <LazyComponent loadComponent={loadComponent} {...props} />;
};
